<template>
    <div class="components-container" style="height:500px ">
        <div class="filter-container">

        </div>
        <div v-if="!showZdgc">
            <h1 style="text-align: center">暂无指导过程数据</h1>
        </div>
        <div v-if="showZdgc">
            <el-descriptions class="margin-top" :column="3" border>
                <el-descriptions-item :label-style="{'width':'12.2%'}" label="题目">{{ curdForm.xt }}</el-descriptions-item>
            </el-descriptions>
            <el-descriptions class="margin-top" :column="3" border>
                <el-descriptions-item>
                    <template slot="label">
                        年份
                    </template>
                    {{ curdForm.nf }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        专业
                    </template>
                    {{ curdForm.zymc }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        班级
                    </template>
                    {{ curdForm.bjmc }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        学生
                    </template>
                    {{ curdForm.xm }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        学号
                    </template>
                    {{ curdForm.xh }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        指导教师
                    </template>
                    {{curdForm.zdjs}}
                </el-descriptions-item>
            </el-descriptions>
            <div style="margin-top: 30px" v-for="(option,index) in options">
                <el-descriptions class="margin-top" :column="3" border>
                    <el-descriptions-item label="标题">{{ option.gradeDesignFile.lx }}</el-descriptions-item>
                    <el-descriptions-item label="附件">
                        {{ option.gradeDesignFile.wjm }}
                        <el-button size="small" @click="downloadRec(option)">查看文件</el-button>
                    </el-descriptions-item>
                    <el-descriptions-item label="提交时间">{{ option.gradeDesignFile.cjsj }}</el-descriptions-item>
                    <el-descriptions-item label="指导教师建议" contentClassName="zdjsyj">{{ option.jsyj }}</el-descriptions-item>
                    <el-descriptions-item label="提交时间">{{option.cjsj }}</el-descriptions-item>
                </el-descriptions>
            </div>
            <div style="height: 40px"></div>
        </div>
    </div>
</template>

<script>
import {globalConfig} from "../../../../static/config";

export default {
    name: "GuidanceProcess",
    props:{
        zdgc:{
            type:String,
            default(){
                return ""
            }
        }
    },
    data() {
        return {
            showZdgc:true,//显示指导过程
            zbbh:'',
            tableData:[],
            curdForm:{},//表单信息
            options:{}//指导过程全部信息
        }
    },
    created(){

    },
    watch:{
        options(){
            this.reloadStructure();
        }
    },
    mounted() {
        // this.zbbh = this.$route.query.bh;
        if (this.zdgc != null && this.zdgc != undefined && this.zdgc != ''){
            this.zbbh = this.zdgc ;
        }else {
            this.showZdgc = false;
        }
        this.queryList();
        this.reloadStructure();
    },
    methods: {
        reloadStructure(){
            this.$nextTick(function() {
                $('.zdjsyj').attr('colspan',3);
            })
        },
        downloadRec(option){
            this.$api.scoreManage.graduateDesign2.downloadRec({
                data: option.gradeDesignFile,
                responseType: "blob",
            }).then((response) => {
                const content = response.data;
                const blob = new Blob([content]);
                const fileName = option.gradeDesignFile.wjm ;
                if ("download" in document.createElement("a")) {
                    // 非IE下载
                    const elink = document.createElement("a");
                    elink.download = fileName;
                    elink.style.display = "none";
                    elink.href = URL.createObjectURL(blob);
                    document.body.appendChild(elink);
                    elink.click();
                    URL.revokeObjectURL(elink.href); // 释放URL 对象
                    document.body.removeChild(elink);
                }
            }).catch((error) => {
                console.log(error);
            });
        },
        queryList() { //查询
            this.$api.scoreManage.graduateDesign2.queryOption({
                data: this.zbbh
            }).then((response) => {
                this.options = response.data.data.option ;
                this.curdForm = response.data.data.zb ;
            }).catch((error) => {
                console.log(error);
            });
        },
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// GuidanceProcess.vue?3b092a98